/* eslint-disable */
export default {
  header: 'Support kontaktieren',
  toggleTitle: '1. Aktivieren Sie den Fehlerverfolgungsmodus.',
  toggleDescription:
    'Dies hilft uns, Ihre Probleme zu lokalisieren, beeinträchtigt jedoch möglicherweise geringfügig die Leistung der App.',
  downloadTitle:
    '2. Laden Sie das Fehlerprotokoll herunter, wenn Sie das Problem nachgebildet haben.',
  downloadButton: 'Herunterladen',
  downloadDisabledTitle:
    'Aktivieren Sie den Fehlerverfolgungsmodus, bevor Sie das Fehlerprotokoll herunterladen.',
  sendTitle: '3. Senden Sie das Protokoll an das Support-Team.',
  createSupportTicket: 'Erstellen Sie ein Support-Ticket,',
  sendDescription:
    ' um das Support-Team zu kontaktieren. Senden Sie das Protokoll zur Fehlerbehebung an das Support-Team.',
  privacyNotice:
    'Durch das Herunterladen und Senden des Protokolls stimmen Sie zu, dass RingCentral auf bestimmte protokollbezogene Informationen für die Fehlerbehebung und Fehlerbehandlung zugreifen darf. Weitere Informationen zur Verarbeitung personenbezogener Daten durch RingCentral finden Sie in unseren ',
  privacyNoticeLink: 'Nutzungsbedingungen',
  and: ' und den ',
  privacyNoticeEnd: 'Datenschutzhinweisen.',
  needLeavePage:
    'Sie können diese Seite verlassen, während die Fehlerverfolgung ausgeführt wird. Wenn Sie das Problem nachgebildet haben, kehren Sie zu dieser Seite zurück und laden Sie die Protokolldateien herunter.',
  downloading: 'Wird heruntergeladen',
} as const;

// @key: @#@"header"@#@ @source: @#@"Contact support"@#@
// @key: @#@"toggleTitle"@#@ @source: @#@"1. Turn on error tracking mode"@#@
// @key: @#@"toggleDescription"@#@ @source: @#@"This will help us locate your issues, but may slightly affect your app performance."@#@
// @key: @#@"downloadTitle"@#@ @source: @#@"2. Download the error log when you have replicated the issue."@#@
// @key: @#@"downloadButton"@#@ @source: @#@"Download"@#@
// @key: @#@"downloadDisabledTitle"@#@ @source: @#@"Turn on error tracking mode before you can download error log."@#@
// @key: @#@"sendTitle"@#@ @source: @#@"3. Send the log to support team"@#@
// @key: @#@"createSupportTicket"@#@ @source: @#@"Create a support ticket"@#@
// @key: @#@"sendDescription"@#@ @source: @#@" to get in touch with our support team. Then send the log to the support team for troubleshooting."@#@
// @key: @#@"privacyNotice"@#@ @source: @#@"By downloading and sending us the log, you agree to allow RingCentral to access certain log related information for troubleshooting and error handling purposes. For more information on how RingCentral processes personal data, please review our "@#@
// @key: @#@"privacyNoticeLink"@#@ @source: @#@"Terms of Service"@#@
// @key: @#@"and"@#@ @source: @#@" and "@#@
// @key: @#@"privacyNoticeEnd"@#@ @source: @#@"Privacy Notice."@#@
// @key: @#@"needLeavePage"@#@ @source: @#@"You may leave this page while error tracking is running. When you have replicated the issue, return to this page and download the log files."@#@
// @key: @#@"downloading"@#@ @source: @#@"Downloading"@#@
